import { render, staticRenderFns } from "./warningModal.vue?vue&type=template&id=15c0f194&scoped=true"
import script from "./warningModal.vue?vue&type=script&lang=js"
export * from "./warningModal.vue?vue&type=script&lang=js"
import style0 from "./warningModal.vue?vue&type=style&index=0&id=15c0f194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c0f194",
  null
  
)

export default component.exports